import useConfigValues from '../ReduxFunctions/useConfigValues';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchData } from '../Helpers/externapi';
import { logToCloudWatch } from '../Helpers/cloudwatchLogger';

const HospitalValidation = () => {
    const configValues = useConfigValues('LogoWithoutName');

    const [hospitalCode, setHospitalCode] = useState('');
    const [confirmDisable, setConfirmDisable] = useState(true);
    const [confirmLoad, setConfirmLoad] = useState(false);
    const [hosCodeError, setHosCodeError] = useState('');
    const [logo, setLogo] = useState();

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!configValues.length) {
            return;
        }

        const ohoLogo = configValues.find(val => val.ConfigKey === "LogoWithoutName");
        setLogo(ohoLogo);
    }, [configValues]);

    useEffect(() => {
        if (location.state?.hospitalCodeError) {
            setHosCodeError(location.state.hospitalCodeError);
        }
    }, [location.state]);

    const onChangeHosCode = (e) => {
        setHospitalCode(e.target.value);
        setHosCodeError('');

        if (e.target.value.length === 6) {
            setConfirmDisable(false);
        } else {
            setConfirmDisable(true);
        }
    };

    const handleHospitalCode = async (e) => {
        e.preventDefault();

        if (hospitalCode.length === 6) {
            setConfirmLoad(true);
            const hosCodeResponse = await fetchData('Hospital/hospitalLogin', { hospitalCode })

            if (hosCodeResponse.status) {
                const currentTime = Date.now();
                const expirationTime = currentTime + 24 * 60 * 60 * 1000;

                sessionStorage.setItem('hospitalName', hosCodeResponse.hospitalName);
                sessionStorage.setItem('hospitalImage', hosCodeResponse.hospitalImage);
                sessionStorage.setItem('hospitalId', hosCodeResponse.hospitalId);
                sessionStorage.setItem('hospitalTime', expirationTime);

                const getLogStreamName = () => {
                    const today = new Date().toISOString().split('T')[0];
                    return `${hosCodeResponse.hospitalId} (${hosCodeResponse.hospitalName})-${today}`;
                };

                const logGroupName = process.env.REACT_APP_LOGGER;
                const logStreamName = getLogStreamName();

                await logToCloudWatch(logGroupName, logStreamName, {
                    event: 'Hospital Logged In',
                    details: { hospitalName: hosCodeResponse.hospitalName, hospitalId: hosCodeResponse.hospitalId },
                });

                setHosCodeError('');

                navigate('/verify', { replace: true });
            } else {
                setHosCodeError(hosCodeResponse.message);
            }
            setConfirmLoad(false);
        }
    };

    return (
        <div
            className="d-flex flex-column justify-content-start align-items-center"
            style={{ minHeight: '100vh', width: '100%', backgroundColor: '#0E94C3' }}
        >
            <div className="card hospital-validation-card d-flex flex-column justify-content-center flex-grow-1 align-items-center p-3 pb-5"
                style={{
                    width: '100%',
                    maxWidth: '430px',
                    minHeight: '100vh'
                }}
            >
                <div className="d-flex flex-column align-items-center mb-2 mt-5">
                    {logo ? (
                        <div className="hospital-validation-logo-wrap">
                            <img src={logo.ConfigValue} alt="logo" className="hospital-validation-logo" />
                        </div>
                    ) : (
                        <div className="spinner-border text-primary" aria-hidden="true">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    )}

                    <span className="app-brand-text fw-bolder hospital-validation-brand" >OHOINDIA</span>
                </div>

                <form className='mt-3 w-100' style={{ maxWidth: '360px' }}>
                    <div className="text-start w-100">

                        <div className="d-flex flex-column w-100">
                            <label htmlFor="cardNumber" className="form-label text-black fw-medium" style={{ fontSize: '14px' }}>Enter Hospital Code
                                {/* <span className="text-danger"> *</span> */}
                            </label>

                            <input type="text" className="hospital-validation-input w-100" maxLength="6"
                                id="cardNumber"
                                placeholder='Enter Hospital Code'
                                onChange={(e) => onChangeHosCode(e)}
                            />
                            {hosCodeError && hosCodeError.length > 0 && (
                                <p className='text-danger m-0 mt-1 w-100'>{hosCodeError}</p>
                            )}

                            <div className='d-flex flex-column my-4'>
                                <button type="submit" className="btn btn-primary fw-semibold hospital-validation-submit"
                                    onClick={(e) => handleHospitalCode(e)} disabled={confirmDisable || confirmLoad}
                                >
                                    {confirmLoad ? (
                                        <div className="spinner-border text-white fs-5" aria-hidden="true">
                                            {/* <span className="sr-only">Loading...</span> */}
                                        </div>
                                    ) : (
                                        'SUBMIT'
                                    )}
                                </button>
                            </div>

                            <hr className='mt-5' />

                            <div className="d-flex flex-column align-items-center mb-2">
                                {logo ? (
                                    <img src={logo.ConfigValue} alt="logo"
                                        style={{ height: '40px', width: '40px' }}
                                    />
                                ) : (
                                    <div className="spinner-border text-primary" aria-hidden="true">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                )}

                                <span className="app-brand-text fw-bolder"
                                    style={{ fontSize: '18px', color: '#0094c6' }} >OHOINDIA</span>
                                <span style={{ fontSize: '13px' }}>All rights reserved. Copy right <i className="bi bi-c-circle"></i> OHOINDIA</span>
                                <span className='fw-semibold mt-3' style={{ color: '#0E94C3', fontSize: '13px' }}>Powerd by OHOINDIA TECHNOLOGY v1.0</span>
                                <a href='https://www.ohoindialife.in/privacypolicy' target='_blank' rel='noreferrer'
                                    style={{ color: '#0E94C3' }}>Privacy Policy</a>
                            </div>

                        </div>
                    </div>

                </form>
            </div>
        </div>
    )
};

export default HospitalValidation;
